import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Palette, Search, Warehouse, Star, Video, ArrowRight } from 'lucide-react';
import { services } from '../mockData';

const iconMap = {
  Truck: Truck,
  Palette: Palette,
  Search: Search,
  Warehouse: Warehouse,
  Star: Star,
  Video: Video
};

const Services = ({ showAll = false }) => {
  const displayServices = showAll ? services : services.slice(0, 6);

  return (
    <section className="py-32 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Elegant Section Header - Centered */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center space-x-2 bg-emerald-50 border-2 border-emerald-200 rounded-full px-6 py-2 mb-6">
            <div className="w-2 h-2 bg-emerald-600 rounded-full animate-pulse"></div>
            <span className="text-emerald-700 font-bold text-sm uppercase tracking-wider">Our Services</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            Complete Fulfillment
            <span className="block bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">Solutions</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Everything you need to scale your ecommerce business
          </p>
        </div>

        {/* Elegant Staggered Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {displayServices.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            const isHighlighted = index % 3 === 1;
            
            return (
              <div
                key={service.id}
                className={`group relative bg-gradient-to-br from-white to-emerald-50 rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 border-2 border-emerald-100 hover:border-emerald-300 ${
                  isHighlighted ? 'lg:transform lg:-translate-y-6' : ''
                }`}
              >
                {/* Elegant Icon Circle */}
                <div className="relative mb-6">
                  <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-2xl blur-lg opacity-30"></div>
                  <div className="relative w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <IconComponent size={32} className="text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-black text-gray-900 mb-4 group-hover:text-emerald-700 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Elegant Link */}
                <Link
                  to="/services"
                  className="inline-flex items-center text-emerald-600 font-bold hover:text-emerald-700 transition-all duration-300"
                >
                  <span>Learn More</span>
                  <ArrowRight size={18} className="ml-2 group-hover:translate-x-2 transition-transform" />
                </Link>

                {/* Corner Accent */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-emerald-100 to-transparent rounded-tr-3xl opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
            );
          })}
        </div>

        {/* Elegant CTA */}
        {!showAll && (
          <div className="text-center mt-16">
            <Link
              to="/services"
              className="inline-flex items-center space-x-2 bg-gradient-to-r from-emerald-600 to-teal-600 text-white px-10 py-5 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              <span>View All Services</span>
              <ArrowRight size={24} />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;